import axios from 'axios';
import { Loading,Message } from 'element-ui';
import Router from '../router/index.js'
import {utils} from '@/common/common.js'
var baseUrl_jp ='http://10.10.1.119:10021'  //江鹏 
var baseUrl_sjr ='http://10.10.1.110:10020'  //宋佳融

var baseUrl_dev  ='https://api.dev.ysintelligent.com/yijiajia_admin/d/'  //dev
var baseUrl_test ='https://api.test.ysintelligent.com/yijiajia_admin/d/'  //test
var baseUrl      ='https://api.ysintelligent.com/yijiajia_admin/d/'

var baseUrlBrand_dev  ='https://api.dev.ysintelligent.com/'  // dev
var baseUrlBrand_test ='https://api.test.ysintelligent.com/'  //test
var baseUrlBrand      ='https://api.ysintelligent.com/'

var loginUrl_dev = "https://api.dev.ysintelligent.com/yijiajia_admin/p/"
var loginUrl_test = "https://api.test.ysintelligent.com/yijiajia_admin/p/"
var loginUrl = "https://api.ysintelligent.com/yijiajia_admin/p/"

var imgPrev_dev='https://static.dev.ysintelligent.com'
var imgPrev_test='https://static.test.ysintelligent.com'
var imgPrev='https://static.ysintelligent.com'
//根据环境 改变接口地址 
var environmental=utils.getCurrentApi()
var resultApi={}
if(environmental=='jp'){
    resultApi={
		baseUrl:baseUrl_jp,
		baseUrlBrand: baseUrlBrand_dev,
        loginUrl:loginUrl_dev,
    	imgPrev:imgPrev_dev
    } 
}
if(environmental=='dev'){
    resultApi={
		baseUrl:baseUrl_dev,
		baseUrlBrand: baseUrlBrand_dev,
        loginUrl:loginUrl_dev,
    	imgPrev:imgPrev_dev
    } 
}
if(environmental=='test'){
    resultApi={
		baseUrl:baseUrl_test,
		baseUrlBrand: baseUrlBrand_test,
        loginUrl:loginUrl_test,
    	imgPrev:imgPrev_test
    } 
}
if(environmental=='prod'){
    resultApi={
		baseUrl:baseUrl,
		baseUrlBrand: baseUrlBrand,
        loginUrl:loginUrl,
    	imgPrev:imgPrev
    } 
}

export const api=resultApi
var instance = axios.create({
	baseURL: api.baseUrl,
	timeout: 200000,
	headers: {
		'weiweiHeader': 'foobar66'
	}
});
var instancBrand = axios.create({
	baseURL: api.baseUrlBrand,
	timeout: 200000,
	headers: {
		'weiweiHeader': 'foobar66'
	}
});
var instanceLogin = axios.create({
	baseURL: api.loginUrl,
	timeout: 200000,
	headers: {
		'weiweiHeader': 'foobar66'
	}
});
export function ajaxPost(url, data) {
	let args=data
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: url,
			data:args
		}).then(function(response) {
			// console.log(response,'response')
			if(!response.data.errorCode){
				Message({
					message: "返回数据格式异常",//接口返回一个页面
					type: 'error',
					duration: 1500
				});
			}else if(response.data.errorCode == -20000){
				Message({
					message: "token失效",
					type: 'error',
					duration: 1500
				});
			}else{
				if(response.data.errorCode == 200){
					
				}else{
					Message({
						message:response.data.errorMsg,
						type: 'error',
						duration: 1500
					});
				}
				
			}
			resolve(response.data)//resolve
		}).catch(function(response) {
			Message({
				message: "捕获异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)//reject
		})
	})
	return p
	
}
export function ajaxBrand(url, data) {   // 调用的是品牌商订货会管理后台的接口
	let args=data
	//promise
	let p = new Promise(function(resolve, reject) {
		instancBrand({
			method: 'post',
			url: url,
			data:args
		}).then(function(response) {
			// console.log(response,'response')
			if(!response.data.errorCode){
				console.log('无errerCode')
			}else if(response.data.erroyCode == -20000){
				Message({
					message: "token失效",
					type: 'error',
					duration: 1500
				});
			}else{

			}
			resolve(response.data)//resolve
		}).catch(function(response) {
			Message({
				message: "捕获异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)//reject
		})
	})
	return p
	
}
export function ajaxLogin(url, data) {
	let args=data
	//promise
	let p = new Promise(function(resolve, reject) {
		instanceLogin({
			method: 'post',
			url: url,
			data:args
		}).then(function(response) {
			// console.log(response,'response')
			if(!response.data.errorCode){
				Message({
					message: "返回数据格式异常",//接口返回一个页面
					type: 'error',
					duration: 1500
				});
			}else if(response.data.errorCode == -20000){
				Message({
					message: "token失效",
					type: 'error',
					duration: 1500
				});
			}else{
				if(response.data.errorCode == 200){
					
				}else{
					Message({
						message:response.data.errorMsg,
						type: 'error',
						duration: 1500
					});
				}
				
			}
			resolve(response.data)//resolve
		}).catch(function(response) {
			Message({
				message: "捕获异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)//reject
		})
	})
	return p
	
}



// WEBPACK FOOTER //
// ./src/common/request.js